import React, { useState } from 'react';
import { Box } from '@mui/material';
import { errorNames } from '../../../utils/constants';
import { photos } from '../../../utils/data';
import { AvatarFromAws } from '../../avatarFromAws/AvatarFromAws';
import { ErrorText } from '../../errorText/ErrorText';
import { photoWrapper, useStyles } from './photoForm.styles';
import { IProps, IUrl } from './types';

export const PhotoForm = (props: IProps): JSX.Element => {
  const classes = useStyles();
  const { setSelectedPhoto, selectedPhoto, submitted } = props;
  return (
    <Box>
      <Box
        sx={photoWrapper}
        className={`${submitted && selectedPhoto === '' && classes.photoError}`}
      >
        {photos.map((item: IUrl) => (
          <div onClick={() => setSelectedPhoto(item.key)}>
            <AvatarFromAws
              photoKey={item.key}
              className={`${classes.img} ${selectedPhoto === item.key && classes.activeImg}`}
              notPublic
            />
          </div>
        ))}
      </Box>
      <Box className={classes.errors}>
        {submitted && selectedPhoto === '' && <ErrorText text={errorNames.imageRequired} />}
      </Box>
    </Box>
  );
};
